<template>
    <div>
        <address-delivery-phase
            v-if="model.is_signed"
            :initial-delivery-phase="addressDeliveryPhase"
            inline-template
        >
            <div class="flex">
                <div v-if="deliveryPhase.completed" class="flex items-center">
                    <span class="icon-circle is-md bg-success">
                        <font-awesome-icon icon="check" class="text-lg text-white pt-px" />
                    </span>

                    <div class="ml-sm flex-none">
                        <div>{{ deliveryPhase.completed_at }}</div>
                    </div>

                    <edit-address-delivery-phase-button
                        :delivery-phase="deliveryPhase"
                        completed-classes="btn-icon"
                        @delivery-phase-updated="updateDeliveryPhase"
                    >
                        <font-awesome-icon icon="pencil" size="sm" />
                    </edit-address-delivery-phase-button>
                </div>

                <edit-address-delivery-phase-button
                    v-if="! deliveryPhase.completed"
                    :delivery-phase="deliveryPhase"
                    uncompleted-classes="btn btn-sm border border-neutral-dark text-neutral-dark btn-secondary"
                    @delivery-phase-updated="updateDeliveryPhase"
                />
            </div>
        </address-delivery-phase>
        <span v-else>-</span>
    </div>
</template>
<script>
    export default {
        props: {
            model: {
                type: Object,
                required: true,
            },
            column: {
                type: Object,
                required: true,
            },
        },
        computed: {
            addressDeliveryPhase() {
                return this.model.delivery_phases_with_all_types.find((phase) => phase.type === this.column.value);
            },
        },
    };
</script>
